"use client";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useBannerStaticStore } from "../../store/bannerStaticStore";

type BannerStaticProps = {
  className?: string;
  children?: React.ReactNode;
  blur?: boolean;
};

export default function BannerStatic({
  className = "",
  children,
  blur = false,
}: BannerStaticProps) {
  const { bannerStatic, fetchBannerStatic } = useBannerStaticStore();
  const location = useLocation();

  const currentLang: "en" | "id" = location.pathname.startsWith("/id")
    ? "id"
    : "en";

  useEffect(() => {
    fetchBannerStatic(currentLang);
  }, [fetchBannerStatic, currentLang]);

  if (!bannerStatic) return null;

  return (
    <section className={`relative w-full h-[80vh] overflow-hidden ${className}`}>
      <div className="relative w-full h-full">
        {/* Desktop */}
        <div
          className="absolute inset-0 bg-cover bg-center hidden md:block"
          style={{ backgroundImage: `url(${bannerStatic.image_desktop})` }}
        />

        {/* Mobile */}
        <div
          className="absolute inset-0 bg-cover bg-center md:hidden"
          style={{ backgroundImage: `url(${bannerStatic.image_mobile})` }}
        />

        {/* Overlay */}
        <div
          className={`absolute inset-0 bg-black/40 transition-all duration-500 ${
            blur ? "backdrop-blur-md" : ""
          }`}
        />

        {/* Content */}
        <div className="relative z-10 h-full flex flex-col justify-center text-white container-banner sm:px-10 lg:px-20 xl:px-28 max-w-[1920px] mx-auto">
          <h1 className="text-3xl md:text-5xl font-bold mb-4">
            {bannerStatic.title[currentLang]}
          </h1>

          {bannerStatic.sub_title?.[currentLang] && (
            <p className="text-lg max-w-2xl">
              {bannerStatic.sub_title[currentLang]}
            </p>
          )}

          {children}
        </div>
      </div>
    </section>
  );
}